import { useSelectorToQueryParam, type Option } from '../shared/useSelectorToQueryParam'

export function useSorter(sortOptions: Option[], defaultValue = 'recommended') {
  const {
    optionSelected: sortOrder,
    pushQueryParam,
  } = useSelectorToQueryParam(
    {
      label: 'sort',
      defaultValue,
    }
  )

  function pushSortOrder(currentQuery: Option) {
    pushQueryParam(currentQuery.value)
  }

  const selectedSortOptionLabel = computed(() => {
    const final = sortOptions.filter((opt) => opt.value === sortOrder.value.value)
    // if (!final.length) {
    //   return 'Recomendados'
    // }

    return final[0].label
  })

  return {
    sortOrder,
    pushSortOrder,
    sortOptions,
    selectedSortOptionLabel
  }
}
